import {
    styled,
    Box as MuiBox,
    Grid,
    Button as MuiButton,
} from "@mui/material";

export const Box = styled(MuiBox)(({ theme }) => {
    return {
        height: "440px",
        width: "320px",
        backgroundColor:
            theme.palette.mode === "dark"
                ? theme.palette.info.light
                : theme.palette.secondary.main,
        borderRadius: "16px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        border: `1px solid`,
    };
});

export const BadgeContainer = styled(Grid)(({ theme }) => {
    return {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
    };
});

export const BadgeImg = styled("img")(({ theme }) => {
    return {
        width: "auto",
        height: "208px",
        zIndex: "2",
    };
});

export const RibbonImg = styled("img")(({ theme }) => {
    return {
        width: "407px",
        height: "100px",
        position: "absolute",
        top: "-30px",
    };
});

export const Circle = styled("div")(({ theme }) => {
    return {
        borderColor:
            theme.palette.mode === "dark"
                ? theme.palette.divider
                : theme.palette.secondary.main,
        borderWidth: "20px",
        borderStyle: "solid",
        borderRadius: "50%",
        position: "absolute",
        width: "262px",
        height: "262px",
        left: "30px",
        top: "75px",
    };
});

export const BadgeButton = styled(MuiButton)(({ theme }) => {
    return {
        marginTop: "10px",
        color: "white",
        [theme.breakpoints.down("md")]: {
            marginBottom: "40px",
        },
    };
});

export const TextGrid = styled(Grid)(({ theme }) => {
    return {
        padding: "30px",
        [theme.breakpoints.down("md")]: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
        },
    };
});
